import type { FC } from 'react';

import cn from 'classnames';

import { COMMUNITY_SIDEBAR_WIDTH_CLASS } from '~/constants/community';

import { SkeletonBlock } from '../ui/SkeletonBlock';

import { useNavigationV2Enabled } from '../../_hooks/useNavigationV2Enabled';

type SidebarSkeletonProps = {
  variant?: 'desktop' | 'mobile';
};

export const SidebarSkeleton: FC<SidebarSkeletonProps> = ({ variant = 'desktop' }) => {
  const isMobile = variant === 'mobile';
  const navigationV2Enabled = useNavigationV2Enabled();

  return (
    <aside
      className={cn('flex flex-col justify-between animate-pulse', {
        [`${COMMUNITY_SIDEBAR_WIDTH_CLASS} shrink-0 p-3 h-full`]: !isMobile,
        'w-full p-4 h-full': isMobile,
      })}
      aria-hidden
    >
      <div className="flex flex-col gap-4">
        {!isMobile && !navigationV2Enabled && (
          <div className="flex items-center gap-2 px-2 py-1">
            <SkeletonBlock className="size-8 !rounded-full shrink-0" />
            <SkeletonBlock className="h-4 w-24" />
          </div>
        )}

        {!navigationV2Enabled && <SkeletonBlock className="h-8 w-full !rounded-full" />}

        <div className="flex flex-col gap-1">
          {Array.from({ length: 3 }, (_, i) => (
            <div key={i} className="flex items-center gap-2 px-2 py-1.5">
              <SkeletonBlock className="size-5 !rounded" />
              <SkeletonBlock className="h-4 w-20" />
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-1">
          <SkeletonBlock className="h-3 w-14 mx-2 my-1" />
          {Array.from({ length: 2 }, (_, i) => (
            <div key={i} className="flex items-center gap-2 px-2 py-1.5">
              <SkeletonBlock className="size-5 !rounded" />
              <SkeletonBlock className="h-4 w-16" />
            </div>
          ))}
        </div>
      </div>

      {(isMobile || !navigationV2Enabled) && <SkeletonBlock className="h-10 w-full !rounded-full" />}
    </aside>
  );
};
